const api = {
  GET_LIST_MERCHANT_CALLBACK: '/index.php?r=api/v1/merchant/merchant-callback/index',
  GET_DETAIL_TABLE_MERCHANT_CALLBACK: '/index.php?r=api/v1/merchant/merchant-callback/get-detail-sublist',
  GET_DETAIL_MERCHANT_CALLBACK: '/index.php?r=api/v1/merchant/merchant-callback/get-detail',
  GENERATE_SNAP_OUTBOUND_PAIR_KEY: '/index.php?r=api/v1/merchant/merchant-callback/gen-clients-pair-pem-key',
  UPDATE_MERCHANT_SNAP: '/index.php?r=api/v1/merchant/merchant-callback/update',
};

export default api;